module.exports = require('./helpers/bundle-url').getBundleURL('drLhz') + "../assets/images/logo.2e3a6cef.webp";